import AgendaList from "Components/Agenda/AgendaList/AgendaList";
import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";

const Agenda = () => {
  const eventId = localStorage.getItem("eventId");

  return (
    <>
      <Header moduleName={"agenda"} />
      <section className="inner_sec">
        <div className="container">
          <AgendaList showTitle={true} eventId={eventId} />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Agenda;
